// service.js
import get from "lodash/get";
import { WEEK_IN_SECONDS, HOUR_IN_SECONDS } from "apm/constants/service";
import { createSelector } from "reselect";
import { parse } from "query-string";

// selectors
export const getService = (state, props) => {
  const service = props.match.params.service;
  return service === undefined ? null : service.toLowerCase();
};

export const getDuration = props => {
  const duration = parse(props.location.search).duration;
  if (duration !== undefined) {
    return Number(duration);
  }
  return HOUR_IN_SECONDS;
};

export const getTimeShift = props => {
  return +parse(props.location.search).time_shift || WEEK_IN_SECONDS;
};

export const getResponseTimeComposite = createSelector(
  [getService],
  service => {
    return `
    group_by("@host",
      zero_fill(
        mean(
          s("trace.service.host.response_time",
            { "service": "${service}" },
            { "period": "60" }
          )
        )
      )
    )
  `;
  }
);

export const getRequestRateComposite = createSelector([getService], service => {
  return `
    group_by("@host",
      zero_fill(
        mean(
          s("trace.service.host.requests",
            { "service": "${service}" },
            { "period": "60" }
          )
        )
      )
    )
  `;
});

export const getMetricStreams = (data, idx) =>
  get(data, `viewer.account.metricsStreams.edges[${idx || 0}].node.metric`, {});

export const getCurrentServiceKips = data =>
  get(data, "viewer.account.services.edges[0].node", {});

export const getHostNames = data =>
  get(data, "viewer.account.services.edges[0].node.hosts.edges", []);

export const getCurrentErrorRate = data =>
  get(data, "viewer.account.services.edges[0].node.errorRate", []);

export const getShiftedErrorRate = data =>
  get(data, "viewer.account.services.edges[0].node.errorRate.comparison", {});

export const getCurrentRequests = data =>
  get(data, "viewer.account.services.edges[0].node.requests", []);

export const getShiftedRequests = data =>
  get(data, "viewer.account.services.edges[0].node.requests.comparison", {});

export const getCurrentResponseTime = data =>
  get(data, "viewer.account.services.edges[0].node.responseTime", []);

export const getShiftedResponseTime = data =>
  get(
    data,
    "viewer.account.services.edges[0].node.responseTime.comparison",
    {}
  );

export const getCurrentCpuUtilization = data =>
  get(data, "viewer.account.services.edges[0].node.cpuUtilization", []);

export const getShiftedCpuUtilization = data =>
  get(
    data,
    "viewer.account.services.edges[0].node.cpuUtilization.comparison",
    {}
  );
